export const it = {
    GENERAL_DELETE: 'Cancellare',
    GENERAL_CANCEL: 'Annullare',
    GENERAL_SAVE: 'Salva',
    GENERAL_SETTINGS: 'Impostazioni',
    JSON_EDITOR_REVISION_ACTIVE: 'attivo',
    JSON_EDITOR_REVISION_DELETE_CONFIRM: 'Elimina davvero la revisione?',
    JSON_EDITOR_REVISION_SAVE_SUCCESS: 'Revisione salvata',
    JSON_EDITOR_REVISION_SAVE_FAILURE: 'La revisione non è stata salvata',
    JSON_EDITOR_REVISION_DELETE_SUCCESS: 'Revisione cancellata',
    JSON_EDITOR_REVISION_DELETE_FAILURE: 'La revisione non è stata cancellata',
    JSON_EDITOR_ACTIVE_REVISION_CANT_BE_DELETED: 'Le revisioni attive non possono essere salvate',
    JSON_EDITOR_REVISION_ACTIVATE_SUCCESS: 'Revisione attivata',
    JSON_EDITOR_REVISION_ACTIVATE_FAILURE: 'Revisione non è stata attivata',
    JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION: 'Impossibile modificare la revisione già approvata',
    JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS: 'Non è possibile modificare la revisione di altri amministratori',
    JSON_EDITOR_INVALID_JSON: 'JSON non valido',
    MISSING_APPROVAL_PERMISSION: 'Non avete il permesso di approvare le revisioni.',
    DIRECTIVE_PHONE_PRESET_CONFIGURE_GLOBAL: 'Configurare il telefono predefinito a livello globale?',
    DIRECTIVE_CHECK_BEFORE_EXPORT_ENABLED: "I report devono essere controllati prima dell'esportazione in integrazione",
    DIRECTIVE_EXPORT_SETTINGS_CONFIGURE_GLOBAL: 'Configura le preferenze a livello globale?',
    DIRECTIVE_APP_CRM_CONNECTION_DISABLED: "Disattiva l'app CRM-Connection in Scanner biglietti da visita",
    DIRECTIVE_EXPORT_SETTINGS_DIRECT_EXPORT: "Trasferire gli indirizzi direttamente all'interno selezionato (CRM).",
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_CONFIGURE_GLOBAL: "Configurare l'esportazione automatica a livello globale?",
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_ENABLED: "Attiva l'esportazione automatica",
    DIRECTIVE_INTERVAL_EXPORT_SETTINGS_TIMEOUT: "Esegui l'esportazione automatica dopo alcuni minuti di inattività",
    DIRECTIVE_SELECT_INTEGRATION_CHOOSE: 'Impostazioni di integrazione',
    DIRECTIVE_SELECT_INTEGRATION_CRM_HEADER: 'Sistemi CRM:',
    DIRECTIVE_SELECT_INTEGRATION_EMAIL_HEADER: 'Integrazioni email:',
    DIRECTIVE_SELECT_INTEGRATION_MA_HEADER: 'Marketing automations:',
    DIRECTIVE_SELECT_INTEGRATION_OTHER_HEADER: 'Altre integrazioni:',
    DIRECTIVE_VISITREPORT_MANDATORY_CONFIGURE_GLOBAL: 'Configurare i campi di contatto obbligatori a livello globale?',
    INTEGRATION_MODAL_SNAPADDY_API_HEADER: 'impostazioni API di snapAddy',
    INTEGRATION_MODAL_SNAPADDY_API_ENDPOINT_URL: 'Inserisci URL',
    INTEGRATION_MODAL_SNAPADDY_API_HTTP_METHOD: 'Metodo HTTP',
    INTEGRATION_MODAL_SNAPADDY_API_AUTH_HEADER: 'Autorizzazione-Header',
    INTEGRATION_MODAL_WECLAPP_HEADER: 'Impostazioni',
    INTEGRATION_MODAL_SUGAR_HEADER: 'Impostazioni SugarCRM',
    INTEGRATION_MODAL_SUITE_HEADER: 'Impostazioni SuiteCRM',
    INTEGRATION_MODAL_SUGAR_USE_V41: "Io uso l'edizione Sugar Community Edition",
    INTEGRATION_MODAL_CENTRALSTATION_HEADER: 'Impostazioni CentralStationCRM',
    INTEGRATION_MODAL_SAPC4C_HEADER: 'Impostazioni SAP Sales Cloud',
    INTEGRATION_MODAL_SAGE_HEADER: 'Impostazioni',
    INTEGRATION_MODAL_DYNAMICS_HEADER: 'Impostazioni di Microsoft Dynamics',
    INTEGRATION_MODAL_ZAPIER_HEADER: 'Impostazioni',
    INTEGRATION_MODAL_SUITE_EXPORT_2: 'Esportazione CRM 2.0 attivata',
    INTEGRATION_MODAL_SUITE_PLAINTEXT_PASSWORD: 'Inviare la password in chiaro (la password non verrà salvata)',
    INTEGRATION_MODAL_GENERIC_ENDPOINT_URL: 'Inserisci URL',
    INTEGRATION_MODAL_OPTIVO_HEADER: 'Episerver Campaign impostazioni',
    INTEGRATION_MODAL_OPTIVO_AUTHTOKEN: 'Codice di autorizzazione',
    INTEGRATION_MODAL_OPTIVO_AUTO_EXPORT: 'Invia automaticamente i rapporti a Episerver Campaign dopo aver controllato',
    INTEGRATION_MODAL_OPTIVO_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/episerver-campaign-authorization-code-and-mailingid',
    INTEGRATION_MODAL_MANDRILL_HEADER: 'Impostazioni Mandrill/MailChimp',
    INTEGRATION_MODAL_MANDRILL_API_KEY: 'API Key',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_TEMPLATE: 'Nome del modello predefinito',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_EMAIL: 'Posta elettronica predefinita del mittente',
    INTEGRATION_MODAL_MANDRILL_DEFAULT_NAME: 'Nome del mittente predefinito',
    INTEGRATION_MODAL_MANDRILL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/mandrill-api-key-and-template-name',
    INTEGRATION_MODAL_RAPID_MAIL_HEADER: 'Impostazioni RapidMail',
    INTEGRATION_MODAL_RAPID_MAIL_USER_NAME: 'Nome utente API',
    INTEGRATION_MODAL_RAPID_MAIL_PASSWORD: 'Password API',
    INTEGRATION_MODAL_RAPID_MAIL_INVALID_CREDENTIALS: 'Inserisci le credenziali utente API RapidMail valide',
    INTEGRATION_MODAL_RAPID_MAIL_AUTO_EXPORT: 'Invia automaticamente i rapporti a RapidMail dopo aver controllato',
    INTEGRATION_MODAL_RAPID_MAIL_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/rapidmail-api-user-api-password-and-recipient-list-id',
    INTEGRATION_MODAL_HUBSPOT_HEADER: 'Impostazioni Hubspot',
    INTEGRATION_MODAL_HUBSPOT_API_KEY: 'API Key',
    INTEGRATION_MODAL_HUBSPOT_FAQ_LINK: 'https://portal.snapaddy.com/knowledge/hubspot-access-token',
    INTEGRATION_MODAL_SET_DEFAULT_CRM: 'Definire CRM predefinito',
    INTEGRATION_MODAL_SALESFORCE_HEADER: 'Impostazioni Salesforce',
    INTEGRATION_MODAL_CLOSEIO_HEADER: 'Impostazioni Close.io',
    INTEGRATION_MODAL_OUTLOOK_HEADER: 'Impostazioni Outlook',
    REMOVE_SETTINGS_REQUEST: 'Vuoi rimuovere le impostazioni in modo permanente?',
    INT_DYNAMICS_OAUTH_LOGIN: 'Connessione a OAuth',
    INT_DYNAMICS_OAUTH_LOGIN_RESTRICTION: '(Solo per Dynamics CRM 365 Online)',
    INT_DYNAMICS_USE_API: "Utilizzare l'API-esportazione",
    INT_DYNAMICS_USE_LINK: "Utilizzare l'URL-esportazione (senza verifica duplicati)",
    INT_DYNAMICS_WEB_SESSION: 'Utilizzare la sessione web esistente',
    INT_DYNAMICS_WINDOWS: 'Usa il login di Windows',
    INT_SAP_LOGIN_TYPE: 'Tipo di connessione',
    INT_SAP_OAUTH_CLIENT_ID: 'OAuth Client ID',
    INT_SAP_OAUTH_CLIENT_SECRET: 'OAuth Client Secret',
    INT_SAP_USE_WEBSESSION: 'Utilizzare la sessione web esistente',
    INT_SAP_USE_OAUTH: 'OAuth 2.0 via SAML Bearer Assertion',
    INT_SAP_ENTITY_ID: 'Entity ID',
    INTEGRATION_MODAL_GENERIC_PLEASE_CHOOSE: 'Si prega di selezionare ...',
    Salutation: 'Saluto',
    Title: 'Qualifica',
    Vorname: 'Nome',
    Nachname: 'Cognome',
    Firma: 'azienda',
    Funktion: 'Posizione',
    Straße: 'Strada',
    Adresszusatz: 'Indirizzo 2',
    PLZ: 'Zip',
    Ort: 'città',
    Telefon: 'Telefono',
    Mobile: 'Cellulare',
    Fax: 'Fax',
    'E-Mail': 'Email',
    Website: 'Website',
    Land: 'Paese',
    Bundesland: 'Stato federale',
    Kontaktdaten: 'Dettagli del contatto',
};
